import React from 'react'
import 'rc-slider/assets/index.css'
import ReactRange, { SliderHandleProps } from 'rc-slider'
import styles from './range.jcss'
import { cn } from 'ethcss'
import type { RangeProps } from './range.types'

const RangeHandle = (
    offset: number,
    handle: boolean,
    mod: RangeProps['mod'],
    getHandleOffset: (value: number) => void
) => {
    if (!handle) {
        return null
    }

    getHandleOffset(offset)

    return (
        <div
            style={{ left: `${offset}%` }}
            className={cn(
                styles.handle,
                { [styles.handleInactive]: offset === 0 },
                mod === 'blueAccent' ? styles.blueHandle : '',
                mod === 'white' ? styles.whiteHandle : ''
            )}
        />
    )
}

const Range = ({
    className,
    classNameContainer,
    getHandleOffset = () => {},
    handle = true,
    mod = 'darkBlue',
    ...sliderProps
}: RangeProps) => {
    return (
        <div className={cn(styles.rangeWrapper, classNameContainer || '')}>
            <ReactRange
                {...sliderProps}
                className={cn(styles.rangeSlider, styles[mod], className)}
                handle={({ offset }: SliderHandleProps) => RangeHandle(offset, handle, mod, getHandleOffset)}
                defaultValue={0}
            />
        </div>
    )
}

export default Range
